import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingButtons } from "./FloatingButtons";
import { ChatWidget } from "@/components/sparkle/ChatWidget";
import { MobileBar } from "./MobileBar";

export const Layout = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 80);
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1"><Outlet /></main>
      <Footer />
      <div className="h-16 sm:hidden" />
      <FloatingButtons hideOnMobile />
      {pathname !== "/ask" && <ChatWidget />}
      <MobileBar />
    </div>
  );
};
